<template>
  <div id="3dmodel" style="border-radius: 0px !important; border: 0px !important;">
    <model-obj v-if="isObj"
               ref="modelObj" :class="modelObjClass"
               v-on:on-load="onLoad()"
               v-on:on-mousedown="mouseDown()"
               v-on:on-mouseup="mouseUp()"
               :key="key"
               :src="objSrc" :mtl="mtlSrc"
               :style="maxHeightStyle"
               :lights="lights"
               :cameraPosition="cameraPosition"
               :cameraRotation="cameraRotation"
               :controlsOptions="controlsOptions"
               :scale="scale"
    />
    <ModelVision v-if="!isObj"
                 :threeMfSrc="threeMfSrc"
                 :cameraPosition="cameraPositionThree"
                 :key="threeKey"
                 ref="modelThree">

    </ModelVision>
    <b-button block v-on:click="resetCamPos" class="graybutton" v-if="isObj">
      {{ $t('product-model.resetView') }}
    </b-button>
    <b-button block v-on:click="resetCamPosThree" class="graybutton" v-if="!isObj">
      {{ $t('product-model.resetView') }}
    </b-button>
  </div>
</template>

<script>
import {ModelObj} from 'vue-3d-model' //Documentation: https://github.com/hujiulong/vue-3d-model
import { v1 as uuidv1 } from 'uuid';
import url from "@/rest/url";
import * as THREE from 'three';
import ModelVision from "@/components/config-page/utils/ModelVision";

export default {
  name: "ProductModel",
  components: {ModelVision, ModelObj},
  props: {
    id: Number,
    type: String,
    isObj: Boolean,
    visible: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      maxHeight: 0,
      defaultCameraPosition: {x: 100, y: 100, z: 100},
      cameraPosition: {x: 100, y: 100, z: 100},
      cameraPositionThree: {x: 0.5, y: 0.5, z: 0.5},
      defaultCameraPositionThree: {x: 0.5, y: 0.5, z: 0.5},
      cameraRotation: {x: Math.atan( - 1 / Math.sqrt( 2 ) ), y: Math.PI / 4},
      controlsOptions: { enableKeys: false},
      scale: {x:1, y:1, z:1},
      lights: [
        {
          type: 'AmbientLight',
          position: { x: 0, y: 0, z: 0},
          color: 0x606060,
          intensity: 1.0,
        },
        {
          type: 'DirectionalLight',
          position: { x: -100, y: -50, z: 100 },
          color: 0xC0C0C0,
          intensity: 1.0,
        },
        {
          type: 'DirectionalLight',
          position: { x: 100, y: 50, z: -100 },
          color: 0xC0C0C0,
          intensity: 1.0,
        }
      ],
      key: uuidv1(),
      threeKey: 0,
      mousePressed: false
    }
  },
  watch: {
    type: {
      handler() { //save camera position before reload
        if (this.$refs.modelObj) {
          this.cameraPosition = this.$refs.modelObj.camera.position;
        }
        if (this.$refs.modelThree) {
          this.cameraPositionThree = this.$refs.modelThree.camera.position;
        }
      }
    }
  },
  computed: {
    objSrc() {
      return url.apiLocation + '/loadType3d/' + this.id + '/' + this.type + '.obj/';
    },
    mtlSrc() {
      return url.apiLocation + '/loadType3d/' + this.id + '/' + this.type + '.mtl/';
    },
    threeMfSrc() {
      this.rerenderThree()
      return url.apiLocation + '/loadType3d/' + this.id + '/' + this.type + '.3mf/';
    },
    maxHeightStyle() {
      if (this.maxHeight !== 0) {
        return 'max-height: ' + this.maxHeight + 'px;';
      }
      return '';
    },
    modelObjClass() {
      if (this.mousePressed)
        return 'mousePressed'
      else
        return 'hover'
    }
  },
  methods: {
    onLoad() {

      this.setScale();

      /**TODO So richtig funktioniert ein flüssiges Laden an dieser Stelle noch nicht.
       * Meistens flackert es immer noch.
       * Der Gedanke hier war das neue Element nachzuladen, während das alte Element noch da ist
       * und nach einem kurzen delay das alte Element zu löschen. Dadurch soll vermieden werden das gar kein
       * Element zu sehen ist. Manchmal wird die Komponente aber neu gezeichnet, das hat dann ein flackern
       * (kurz ist kein Element zu sehen)
       * zur Folge. Warum die Komponente manchmal neu gezeichnet wird und manchmal nicht, konnte ich noch
       * nicht feststellen.
       */
      setTimeout(() => {
        let length = this.$refs.modelObj.wrapper.children.length;
        this.$refs.modelObj.wrapper.children.splice(0, length - 1);
      }, 3000);
    },

    mouseDown() {
      this.mousePressed = true;
    },

    mouseUp() {
      this.mousePressed = false;
    },
    rerenderThree() {
      this.threeKey += 1;
    },
    resetCamPos() {
      this.cameraPosition = this.defaultCameraPosition;
      this.key = uuidv1();
      this.setScale();
    },
    resetCamPosThree() {
      this.cameraPositionThree = this.defaultCameraPositionThree;
      this.rerenderThree()
      // let temp = this.threeMfSrc;
      // this.threeMfSrc = "";
      // this.threeMfSrc = temp;
    },
    setScale() {
      this.$refs.modelObj.scale = {x: 1, y: 1, z:1}; // default scale
      var boundingBox = new THREE.Box3().setFromObject(this.$refs.modelObj.object);
      var vec = new THREE.Vector3();
      var objwidth = boundingBox.getSize(vec).z > boundingBox.getSize(vec).y ? boundingBox.getSize(vec).z : boundingBox.getSize(vec).y * 1.1;

      //controls.maxDistance = objwidth * 4;
      // this.cameraPosition.z = objwidth * 3;

      if (!objwidth)
        objwidth = 100;

      let scaleRatio = 100 / objwidth;
      //alert(objwidth + "-" + scaleRatio);
      this.scale = {x: scaleRatio, y: scaleRatio, z:scaleRatio};
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.maxHeight = this.$el.clientHeight
    })
  }
}
</script>

<style scoped>

.hover {
  cursor: grab;
}

.mousePressed {
  cursor: grabbing;
}

</style>